// index.js
// Propósito: Punto de entrada del frontend React, renderiza App en el DOM.

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { AuthProvider } from './context/AuthContext.js';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
	<AuthProvider>
		<App />
	</AuthProvider>
);
